import React, {useContext, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {Field, Form, Formik} from 'formik';
import {TextField} from 'formik-mui';
import {DispatchContext} from '../../store';
import {SNACKBAR_OPEN} from '../../reducers';
import {userInvitationServices} from '../../services/InvitationServices';
import {Avatar, Button, Card, Container, Grid, InputAdornment} from '@mui/material';
import Typography from '@mui/material/Typography';
import {Images} from '../../common/Assets/Images';
import IconButton from '@mui/material/IconButton';
import {Visibility, VisibilityOff} from '@mui/icons-material';

export default function ConfirmInvitation() {
  const navigate = useNavigate();
  const dispatch = useContext(DispatchContext);
  const location = useLocation();
  const urlParams = new URLSearchParams(location?.search);
  const token = urlParams.get('signature');
  const email = urlParams?.get('email');
  const timestamp = urlParams?.get('timestamp');
  const user_id = urlParams?.get('user_id');
  const [showPassword, setShowPassword] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState(false);

  const initialValues = {
    signature: token,
    user_id: parseInt(user_id),
    email: email,
    timestamp: parseInt(timestamp),
    password: '',
    password_confirm: '',
  };

  const validate = (values) => {
    const errors = {};
    if (values.password !== values.password_confirm) {
      errors.password_confirm = 'Passwords do not match';
    }
    return errors;
  };

  const invitationConfirmation = async (values, {reset}) => {
    userInvitationServices('post', null, {...values}, dispatch).then(res => {
      dispatch({
        type: SNACKBAR_OPEN,
        payload: {isNotify: true, severity: 'success', message: 'User Verified'}
      });
      navigate('/agency-login');
    });
  };

  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleClickConfirmPassword = () => {
    setConfirmPassword(!confirmPassword);
  };

  return (
    <React.Fragment>
      <Container className={'flex-center'} sx={{height: '100vh', bgcolor: '#e7f0fe'}}>
        <Grid container spacing={2}>
          <Grid item ld={12} md={12} sm={12} xs={12} align={'center'}>
            <Card className={'box-shadow'} sx={{p: 6, maxWidth: 550}}>
              <Avatar sx={{width: 70, height: 70}} src={Images.logoWhite} alt={'museum_logo'}/>
              <Typography variant="h6" className={'text-bold'}>
                Invitation Confirmation Page
              </Typography>
              <Typography sx={{mb: 3}}>
                Remember Your Credentials for Convenience
              </Typography>
              <Formik
                initialValues={initialValues}
                onSubmit={invitationConfirmation}
                validateOnBlur={true}
                validate={validate}
              >
                {({
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                    setFieldValue,
                    ...formik
                  }) => (
                  <Form>
                    <Grid container spacing={2}>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Field component={TextField} name="email" label="Email"
                               variant="outlined" fullWidth/>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Field component={TextField} name="password" label="Password"
                               type={!showPassword ? 'password' : "text"}
                               InputProps={{
                                 endAdornment: (
                                   <InputAdornment position="end">
                                     <IconButton
                                       aria-label="toggle password visibility"
                                       onClick={handleClickShowPassword}
                                       edge="end"
                                     >
                                       {showPassword ? <Visibility sx={{fontSize: 20}}/> : <VisibilityOff sx={{fontSize: 20}}/>}
                                     </IconButton>
                                   </InputAdornment>
                                 ),
                               }}
                               variant="outlined" fullWidth/>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Field component={TextField} name="password_confirm" label="Confirm password"
                               type={!confirmPassword ? 'password' : 'text'}
                               InputProps={{
                                 endAdornment: (
                                   <InputAdornment position="end">
                                     <IconButton
                                       aria-label="toggle password visibility"
                                       onClick={handleClickConfirmPassword}
                                       edge="end"
                                     >
                                       {confirmPassword ? <Visibility sx={{fontSize: 20}}/> : <VisibilityOff sx={{fontSize: 20}}/>}
                                     </IconButton>
                                   </InputAdornment>
                                 ),
                               }}
                               variant="outlined" fullWidth/>
                      </Grid>
                      {errors.password_confirm && touched.password_confirm && (
                        <div>{errors.password_confirm}</div>
                      )}
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Button fullWidth disableElevation variant="contained"
                                disabled={errors.password_confirm && touched.password_confirm}
                                type="submit">Confirm</Button>
                      </Grid>
                      <Grid item lg={12} md={12} sm={12} xs={12}>
                        <Typography>Copyright © Museum 2024 - {new Date().getFullYear()}</Typography>
                      </Grid>
                    </Grid>
                  </Form>
                )}
              </Formik>
            </Card>
          </Grid>
        </Grid>
      </Container>
    </React.Fragment>
  );
}